import { Button, Flex, Typography } from "antd"

export const WithdrawalInCryptocurrencyStepUI = () => {
  return (
    <Typography.Text>
      Once the address has been added to the whitelist, you can create a
      withdrawal request.
      <br />
      Depending on the blockchain, the funds will be transferred to the
      specified address within a few minutes to a few hours.
    </Typography.Text>
  )
}
